import * as d3 from 'd3'

export default {
  methods: {

    draw_ChartCanvas(list) {
      let main = this.title.main
      let sub = this.title.sub

      let canvas = this.canvasChart
      .append('g')
      .attr('id', `CHART_${list.id}_${this.localId}`)
      .attr('transform', `translate(${list.x +.5}, ${list.y + .5})`)

      if(main.visible == 'Y'){
        canvas
        .append('text')
        .attr('id', `TITLE_MAIN_${list.id}_${this.localId}`)
        .attr('x', main.x) .attr('y', main.y)
        .style('font-size', main.tSize)
        .style('fill', main.tColor)
        .text(()=> {
          if(main.name == '') return list.name; else return main.name
        })
      }

      if(sub.visible == 'Y'){
        let main_x = this.getNode(`#TITLE_MAIN_${list.id}_${this.localId}`)+5
        canvas
        .append('text')
        .attr('id', `TITLE_SUB_${list.id}_${this.localId}`)
        .attr('x', (sub.x=='auto') ? main_x : sub.x)
        .attr('y', sub.y)
        .style('font-size', sub.tSize)
        .style('fill', sub.tColor)
        .text(sub.name)

        let sub_x = this.getNode(`#TITLE_SUB_${list.id}_${this.localId}`)+5
        
        if(Object.keys(this.legends).length > 0 && this.legends.bar)
        canvas
        .append('text')
        .attr('id', `TITLE_TOTAL_${list.id}_${this.localId}`)
        .attr('x', (sub.x=='auto') ? main_x + sub_x : sub.x + sub_x)
        .attr('y', sub.y)
        .style('font-size', this.legends.bar.total.tSize)
        .style('fill', this.legends.bar.total.tColor)
        .text('')
      }

      this.draw_ChartAxis(canvas, list)
      // if(Object.keys(this.legends).length > 0 && this.legends.apply == 'Y') this.draw_Legends(canvas)
    
      this.draw_Grid(canvas, list)
    },

    
    draw_ChartAxis(selection, list) {
      
      let axis = selection
      .append('g')
      .attr('id', `AXIS_${list.id}_${this.localId}`)
      .attr('transform', `translate(${0}, ${this.chart.y})`)

      axis
      .append('line')
      .attr('x1', 0).attr('x2', this.chart.width).attr('y1', this.chart.height).attr('y2', this.chart.height)
      .attr('stroke', '#757575').attr('stroke-width', .5)

      // Primary Axis
      if(this.primary.stroke) {
        axis
        .append('line')
        .attr('x1', this.primary.axisX).attr('x2', this.primary.axisX).attr('y1', 0).attr('y2', this.chart.height)
        .attr('stroke', this.primary.stroke).attr('stroke-width', .5)
      }
      
      if(this.primary.visible=='Y') {
        axis 
        .append('text')
        .attr('transform', `translate(${this.primary.titleX}, ${this.chart.height/2 + this.primary.tSize*0.4}) rotate(-90)`)
        .attr('font-size', this.primary.tSize).attr('fill', this.primary.tColor)
        .attr('text-anchor', 'middle')
        .text(this.primary.title)
      }

      // secondary Axis
      if(this.secondary.stroke) {
        axis
        .append('line')
        .attr('x1', this.secondary.axisX).attr('x2', this.secondary.axisX).attr('y1', 0).attr('y2', this.chart.height)
        .attr('stroke', this.secondary.stroke).attr('stroke-width', .5)
      }

      if(this.secondary.visible=='Y') {
        axis 
        .append('text')
        .attr('transform', `translate(${this.secondary.titleX}, ${this.chart.height/2 + this.secondary.tSize*0.4}) rotate(-90)`)
        .attr('font-size', this.secondary.tSize).attr('fill', this.secondary.tColor)
        .attr('text-anchor', 'middle')
        .text(this.secondary.title)
      }
    },


    draw_Grid(selection, list) {
      let grids = selection
      .append('g')
      .attr('id', `AXIS_${list.id}_${this.localId}`)
      .attr('transform', `translate(0, ${this.chart.y})`)

      let tick = this.chart.height / 5
      for(let i=0; i<6; i++) {
        grids // Grid
        .append('line')
        .attr('x1', 0).attr('x2', this.chart.width)
        .attr('y1', tick * i).attr('y2', tick * i)
        .attr('stroke', '#bcbcbc').attr('stroke-width', .5)
        .attr('opacity', .5)

        // Primary Axis
        if(this.primary.visible=='Y') {
          grids 
          .append('text')
          .attr('id', `PRIMARY_${list.id}_${i}_${this.localId}`)
          .attr('x', (this.primary.position == 'left') ? -2 : this.chart.width + 2)
          .attr('y', this.chart.height - (tick * i) + 3)  
          .attr('font-size', 9).attr('fill', '#757575')
          .attr('text-anchor', (this.primary.position == 'left') ? 'end': 'start')
          .text(()=> {
            let value = (this.primary.max * (i*.2)).toFixed(this.primary.round ? this.primary.round : 0)
            if(this.primary.unit.toLowerCase() == 'k') value = (value/1000).toFixed(1)
            return value + this.primary.unit
          })
        }

        // secondary Axis
        if(this.secondary.visible=='Y') {
          grids 
          .append('text')
          .attr('id', `SECONDARY_${list.id}_${i}_${this.localId}`)
          .attr('x', (this.secondary.position == 'left') ? -2 : this.chart.width + 2)
          .attr('y', this.chart.height - (tick * i) + 3)
          .attr('font-size', 9).attr('fill', '#757575')
          .attr('text-anchor', (this.secondary.position == 'left') ? 'end': 'start')
          .text( ()=> {
            let value = (this.secondary.max * (i*.2)).toFixed(this.secondary.round ? this.secondary.round : 0)
            if(this.secondary.unit.toLowerCase() == 'k') value = (value/1000).toFixed(1)
            return value + this.secondary.unit
          })
        }
      }
    },


  }
}
